import { SITE, priceCta } from "@/config/site";
import { CtaButton } from "./CtaButton";
import { Reveal } from "./Reveal";

export const FinalCta = () => (
  <section className="grain relative overflow-hidden bg-navy-deep py-32 sm:py-44" data-testid="final-cta-section">
    {/* velmi subtilní fotografie autora v pozadí */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-[0.07]"
      style={{ backgroundImage: "url(/assets/author-silhouette-768.webp)" }}
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-gradient-to-b from-navy-deep via-navy-deep/70 to-navy-deep"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-[radial-gradient(70%_100%_at_50%_0%,rgba(201,127,82,0.14),transparent_70%)]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-[radial-gradient(75%_100%_at_50%_100%,rgba(166,90,58,0.14),transparent_70%)]"
    />

    <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-8">
      <Reveal>
        <p
          aria-hidden="true"
          className="font-serif text-[7rem] font-medium leading-none text-copper/25 sm:text-[10rem]"
        >
          40.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="-mt-10 font-serif text-4xl font-medium uppercase leading-[1.1] tracking-wide text-cream sm:-mt-14 sm:text-5xl lg:text-6xl">
          Staň se mužem,
          <br />
          kterého si <span className="italic normal-case text-copper">sám vážíš</span>.
        </h2>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mx-auto mt-12 max-w-2xl space-y-5 text-left text-base leading-relaxed text-cream/70 sm:text-lg">
          <p>
            Můžeš mít lepší práci. Víc peněz. Lepší vztah. Můžeš být úspěšnější u žen, vypadat
            lépe a získat větší respekt svého okolí.
          </p>
          <p>
            Ale nakonec zůstává otázka, před kterou se neschováš:{" "}
            <em className="text-cream">Vážím si člověka, kterým jsem se stal?</em>
          </p>
          <p>
            40 principů lepšího muže ti nedá univerzální odpověď na to, jak máš žít. Může ti ale
            pomoct položit si správné otázky. Podívat se na sebe bez výmluv. Uvědomit si, co už
            funguje — a co je možná čas změnit.
          </p>
          <p>Nemusíš změnit celý svůj život najednou.</p>
          <p className="font-serif text-xl italic text-copper">Začni jedním principem.</p>
        </div>
      </Reveal>

      <Reveal delay={0.3}>
        <div className="mt-14 rounded-lg border border-white/10 bg-navy/60 p-8 backdrop-blur-sm sm:p-10">
          <p className="font-serif text-2xl font-medium uppercase tracking-wide text-cream">
            {SITE.bookTitle}
          </p>
          <p className="mt-2 text-sm text-cream/60">{SITE.bookSubtitle}</p>
          <div className="mx-auto mt-6 h-px w-16 bg-copper/40" aria-hidden="true" />
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em] text-copper/80">
            Zaváděcí cena pro prvních {SITE.introLimit} čtenářů
          </p>
          <p className="mt-3 font-serif text-5xl font-medium text-cream">
            {SITE.introPrice}&nbsp;Kč{" "}
            <span className="ml-2 align-middle font-sans text-sm font-normal text-cream/45">
              Poté {SITE.futurePrice}&nbsp;Kč
            </span>
          </p>
          <div className="mt-8">
            <CtaButton event="final_cta" location="final" size="lg" testId="final-cta">
              {priceCta}
            </CtaButton>
          </div>
          <p className="mt-4 text-xs tracking-wide text-cream/45">
            PDF e-book · jednorázová platba · ihned po zaplacení
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
